import React, { useCallback, useEffect } from 'react';
import {
  Button,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InlineLoading
} from 'carbon-components-react';
import ReactGA from 'react-ga';

const ConfirmLinkingModal: React.FC<Props> = ({
  isModalOpen,
  setIsModalOpen,
  onClickSubmit,
  isConfirmingUserLinking
}) => {
  const handleModalCancel = useCallback(() => {
    ReactGA.event({
      category: 'Onboarding',
      action: 'Clicked modal Cancel button',
      label: 'Step 3'
    });
    setIsModalOpen(false);
  }, [setIsModalOpen]);

  useEffect(() => {
    isModalOpen && ReactGA.modalview('/confirm-account-linking');
  }, [isModalOpen]);

  return (
    <div>
      <ComposedModal
        className="confirm-linking-modal"
        data-testid="confirmLinkingModal"
        open={isModalOpen}
        onClose={handleModalCancel}
        preventCloseOnClickOutside={true}
      >
        <ModalHeader>
          <div className="confirm-linking-modal-header-title">
            REPLACE SUBSCRIPTION
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="confirm-linking-modal-body-title">
            Replace subscription?
          </div>
          <div className="confirm-linking-modal-body-content">
            This BYDA account has an existing subscription. If you proceed,
            we&#39;ll replace it with the new subscription.
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            kind="tertiary"
            onClick={handleModalCancel}
            data-testid="Cancel"
            disabled={isConfirmingUserLinking}
          >
            Cancel
          </Button>
          <Button
            kind="secondary"
            type="button"
            data-testid="submit"
            disabled={isConfirmingUserLinking}
            onClick={() => onClickSubmit()}
          >
            {!isConfirmingUserLinking ? (
              'Yes, replace'
            ) : (
              <InlineLoading
                description={
                  !isConfirmingUserLinking ? 'Yes, replace' : 'Submitting...'
                }
                status={!isConfirmingUserLinking ? 'finished' : 'active'}
                aria-live={'assertive'}
              />
            )}
          </Button>
        </ModalFooter>
      </ComposedModal>
    </div>
  );
};

type Props = {
  isModalOpen: boolean;
  setIsModalOpen: Function;
  onClickSubmit: Function;
  isConfirmingUserLinking?: boolean;
};

export default React.memo(ConfirmLinkingModal);
